module.exports = __webpack_public_path__ + "static/media/-2.fbc98661.png";